// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"muteSwitcher-module_iconContainer_2lKEi","iconLabel":"muteSwitcher-module_iconLabel_CJtFY"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/search/result/muteSwitcher.module.css
// module id = 1023
// module chunks = 1